import { getPendingRequests } from './API';

const toUpperCaseFirstLetter = str => {
  const regex = /sub_account/g;
  str = str.replace(regex, 'Sub-Account')
  return str
    .split(' ')
    .map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};

const formatPendingRequestsDetails = (pendingRequests) => {
  let groupsWithPendingApprovals = pendingRequests.filter(group => !!group.requests.length)
  const groupsWithoutPendingApprovals = pendingRequests.filter(group => !group.requests.length)
  const formatWallets = (wallet) => {
    return {
      walletLabel: wallet.walletLabel,
      walletAddress: wallet.walletAddress,
      dateAdded: wallet.dateAdded.split(' ')[0],
      status: wallet.status,
      allocationPercent: wallet.allocationPercent.toFixed(3),
      auto: wallet.allocationPercent > 0 ? true : false,
      coin: wallet.coin
    }
  }

  const getWalletsWithPendingPayoutUpdates = (detailsObj) => {
    return detailsObj.AfterChange.filter((afterWallet) => {
      const beforeWalletAllocationPercent = detailsObj.BeforeChange.filter(c => c.subAccountWalletId === afterWallet.subAccountWalletId)[0].allocationPercent
      if (+afterWallet.allocationPercent !== +beforeWalletAllocationPercent) {
        return true
      } else {
        return false
      }
    }).map(wallet => wallet.subAccountWalletId);
  }

  groupsWithPendingApprovals = groupsWithPendingApprovals.map(group => {
    return {
      ...group,
      requests: group.requests.map(r => {
        const detailsObj = JSON.parse(r.details)
        switch (r.requestType) {
          case 'add user':
            return {
              ...r,
              requestType: toUpperCaseFirstLetter(r.requestType),
              details: JSON.stringify({
                fullName: detailsObj.fullName,
                emailAddress: detailsObj.emailAddress,
                defaultRole: detailsObj.apiUser ? `${toUpperCaseFirstLetter(detailsObj.roleName)} (API User)` : toUpperCaseFirstLetter(detailsObj.roleName),
                subAccounts: detailsObj.subAccountNames.sort()
              })
            }
          case 'update user':
            return {
              ...r,
              requestType: 'Update User\'s Default Role',
              details: JSON.stringify({
                fullName: detailsObj.fullName,
                emailAddress: detailsObj.emailAddress,
                currentDefaultRole: toUpperCaseFirstLetter(detailsObj.currentAllUserSubAccountsRole),
                newDefaultRole: toUpperCaseFirstLetter(detailsObj.newAllUserSubAccountsRole)
              })
            }
          case 'deactivate user':
              return {
                ...r,
                requestType: toUpperCaseFirstLetter(r.requestType),
                details: JSON.stringify({
                  fullName: detailsObj.fullName,
                  emailAddress: detailsObj.emailAddress,
                })
              }
          case 'update approval threshold':
              return {
                ...r,
                requestType: toUpperCaseFirstLetter(r.requestType),
                details: JSON.stringify({
                  groupName: group.groupName,
                  currentApprovalThreshold: detailsObj.oldApprovalThreshold,
                  newApprovalThreshold: detailsObj.newApprovalThreshold
                })
              }
          case 'add address':
            return {
              ...r,
              requestType: 'Add Payout Address'
            }
          case 'update_payout_settings':
            return {
              ...r,
              requestType: 'Update Payout Settings',
              details: JSON.stringify({
                beforeWalletChanges: detailsObj.BeforeChange.map(formatWallets),
                afterWalletChanges: detailsObj.AfterChange.map(formatWallets)
              }),
              coin: r.coin,
              walletIdsWithPendingUpdates: getWalletsWithPendingPayoutUpdates(detailsObj)
            }
          default:
            return {
              ...r,
              requestType: toUpperCaseFirstLetter(r.requestType)
            }
        }
      })
    }
  })
  return [...groupsWithPendingApprovals, ...groupsWithoutPendingApprovals]
}

const GetPendingRequests = async (accessToken, userID) => {
  try {
    const response = await getPendingRequests(accessToken, userID);
    if (response.data.length === 0) {
      return { success: false, data: 'No data present' };
    }
    const formattedPendingRequests = formatPendingRequestsDetails(response.data)
    return { success: true, data: formattedPendingRequests };
  } catch (error) {
    console.log('Error getting data: ', error.message);
    return {
      success: false,
      data: error?.response?.data?.message
        ? error?.response?.data?.message
        : 'Error'
    };
  }
};

export default GetPendingRequests;
